"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorModeName = exports.ContextTypes = exports.ContextColors = void 0;
var ContextColors;
(function (ContextColors) {
    ContextColors["PRIMARY"] = "primary";
    ContextColors["OVER_PRIMARY"] = "overPrimary";
    ContextColors["LINK"] = "link";
    ContextColors["PRIMARY_ACTIVE"] = "primaryActive";
    ContextColors["PRIMARY_HOVER"] = "primaryHover";
})(ContextColors = exports.ContextColors || (exports.ContextColors = {}));
var ContextTypes;
(function (ContextTypes) {
    ContextTypes["BRAND"] = "brand";
    ContextTypes["BUSINESS"] = "business";
    ContextTypes["CASH"] = "cash";
    ContextTypes["NEUTRAL"] = "neutral";
    ContextTypes["TRADE"] = "trade";
    ContextTypes["WEALTH"] = "wealth";
    ContextTypes["USA"] = "usa";
})(ContextTypes = exports.ContextTypes || (exports.ContextTypes = {}));
var ColorModeName;
(function (ColorModeName) {
    ColorModeName["LIGHT"] = "light";
    ColorModeName["DARK"] = "dark";
})(ColorModeName = exports.ColorModeName || (exports.ColorModeName = {}));
